/**
 * Generated by orval v8.18.0 🍺
 * Do not edit manually.
 * LiftAI API
 * LiftAI elevator/lift asset-management REST API.
 * OpenAPI spec version: 1.0.0 (v1)
 */
import type {
  PatchedViolationNoteDetailRequest,
  ViolationNoteDetail,
  ViolationNoteDetailRequest,
  ViolationNoteListResponse,
  ViolationNotesListParams
} from '../../model';

import { customFetch } from '../../../liftApiMutator';

export type violationNotesListResponse200 = {
  data: ViolationNoteListResponse
  status: 200
}

export type violationNotesListResponseSuccess = (violationNotesListResponse200) & {
  headers: Headers;
};
;

export type violationNotesListResponse = (violationNotesListResponseSuccess)

export const getViolationNotesListUrl = (params?: ViolationNotesListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/violation-notes/?${stringifiedParams}` : `/api/v1/violation-notes/`
}

/**
 * Enhanced list method with metadata
 */
export const violationNotesList = async (params?: ViolationNotesListParams, options?: RequestInit): Promise<violationNotesListResponse> => {

  return customFetch<violationNotesListResponse>(getViolationNotesListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}


export type violationNotesCreateResponse201 = {
  data: ViolationNoteDetail
  status: 201
}

export type violationNotesCreateResponseSuccess = (violationNotesCreateResponse201) & {
  headers: Headers;
};
;

export type violationNotesCreateResponse = (violationNotesCreateResponseSuccess)

export const getViolationNotesCreateUrl = () => {




  return `/api/v1/violation-notes/`
}

/**
 * ViewSet for managing violation notes.
 */
export const violationNotesCreate = async (violationNoteDetailRequest: ViolationNoteDetailRequest, options?: RequestInit): Promise<violationNotesCreateResponse> => {

  return customFetch<violationNotesCreateResponse>(getViolationNotesCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(violationNoteDetailRequest)
  }
);}


export type violationNotesRetrieveResponse200 = {
  data: ViolationNoteDetail
  status: 200
}

export type violationNotesRetrieveResponseSuccess = (violationNotesRetrieveResponse200) & {
  headers: Headers;
};
;

export type violationNotesRetrieveResponse = (violationNotesRetrieveResponseSuccess)

export const getViolationNotesRetrieveUrl = (id: string,) => {




  return `/api/v1/violation-notes/${id}/`
}

/**
 * ViewSet for managing violation notes.
 */
export const violationNotesRetrieve = async (id: string, options?: RequestInit): Promise<violationNotesRetrieveResponse> => {

  return customFetch<violationNotesRetrieveResponse>(getViolationNotesRetrieveUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}


export type violationNotesUpdateResponse200 = {
  data: ViolationNoteDetail
  status: 200
}

export type violationNotesUpdateResponseSuccess = (violationNotesUpdateResponse200) & {
  headers: Headers;
};
;

export type violationNotesUpdateResponse = (violationNotesUpdateResponseSuccess)

export const getViolationNotesUpdateUrl = (id: string,) => {




  return `/api/v1/violation-notes/${id}/`
}

/**
 * ViewSet for managing violation notes.
 */
export const violationNotesUpdate = async (id: string,
    violationNoteDetailRequest: ViolationNoteDetailRequest, options?: RequestInit): Promise<violationNotesUpdateResponse> => {

  return customFetch<violationNotesUpdateResponse>(getViolationNotesUpdateUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(violationNoteDetailRequest)
  }
);}


export type violationNotesPartialUpdateResponse200 = {
  data: ViolationNoteDetail
  status: 200
}

export type violationNotesPartialUpdateResponseSuccess = (violationNotesPartialUpdateResponse200) & {
  headers: Headers;
};
;

export type violationNotesPartialUpdateResponse = (violationNotesPartialUpdateResponseSuccess)

export const getViolationNotesPartialUpdateUrl = (id: string,) => {




  return `/api/v1/violation-notes/${id}/`
}

/**
 * ViewSet for managing violation notes.
 */
export const violationNotesPartialUpdate = async (id: string,
    patchedViolationNoteDetailRequest?: PatchedViolationNoteDetailRequest, options?: RequestInit): Promise<violationNotesPartialUpdateResponse> => {

  return customFetch<violationNotesPartialUpdateResponse>(getViolationNotesPartialUpdateUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(patchedViolationNoteDetailRequest)
  }
);}


export type violationNotesDestroyResponse204 = {
  data: void
  status: 204
}

export type violationNotesDestroyResponseSuccess = (violationNotesDestroyResponse204) & {
  headers: Headers;
};
;

export type violationNotesDestroyResponse = (violationNotesDestroyResponseSuccess)

export const getViolationNotesDestroyUrl = (id: string,) => {




  return `/api/v1/violation-notes/${id}/`
}

/**
 * ViewSet for managing violation notes.
 */
export const violationNotesDestroy = async (id: string, options?: RequestInit): Promise<violationNotesDestroyResponse> => {

  return customFetch<violationNotesDestroyResponse>(getViolationNotesDestroyUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}


